import React from 'react';
import { DeleteContactContainer } from './DeleteContactContainer';
import PropTypes from 'prop-types';
import { mainBuilder } from '../main/main-builder';
import { ModuleRegistry } from 'react-module-container';

const DeleteContactExternalContainer = (props) => {
  return <DeleteContactContainer {...props} />;
};

const DeleteContactExternal = mainBuilder({
  baseUrl: '/contacts-server',
  Root: DeleteContactExternalContainer,
  stores: () => {},
});

export default DeleteContactExternal;
